import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";

import loginSlice from "./slices/auth/loginSlice";
import loginUsernameSlice from "./slices/auth/loginUsernameSilce";
import signupSlice from "./slices/auth/signupSlice";
import verifyOtpSlice from "./slices/auth/emailVerificationSlice";
import resendOtpSlice from "./slices/auth/resendOtpSlice";
import kycVerifyOtpSlice from "./slices/auth/kycVerificationSlice";
import getProfileSlice from "./slices/profile/fetchProfileSlice";
import getProfileKycSlice from "./slices/profile/fetchKycProfileSlice";
import editProfileSlice from "./slices/profile/updateProfileSlice";
import signoutSlice from "./slices/auth/signoutSlice";
import addKYCSlice from "./slices/auth/kyc-management/addKycSlice";
import resendOtpKYCSlice from "./slices/auth/kyc-management/resendOtpKycSlice";
import verifyOtpKYCSlice from "./slices/auth/kyc-management/verifyOtpKycSlice";
import updateProfileSlice from "./slices/auth/kyc-management/updateProfileSlice";
import addBankDetailSlice from "./slices/wallet/addBankSlice";
import getBankDetailSlice from "./slices/wallet/fetchBankDetailSlice";
import deleteBankDetailSlice from "./slices/wallet/removeBankDetailSlice";
import loginGoogleSlice from "./slices/auth/loginGoogleSlice";
import configSlice from "./slices/auth/configSlice";
import locationReducer from "./slices/auth/locationSlice";
import deviceReducer from "./slices/auth/deviceSlice";
import getAllNotificationSlice from "./slices/notification/getAllNotificationSlice";
import markSeenSlice from "./slices/notification/markSeenSlice";
import markSeenAllSlice from "./slices/notification/markSeenSlice";
import getReferralEarningSlice from "./slices/referralEarning/referralEarningSlice";
import getDreamCasinoGamesSlice from "./slices/games/casino/dreamCasinoGameListSlice";
import getCmsSlice from "./slices/auth/cmsSlice";
import checkUserSlice from "./slices/auth/checkUserSlice";
import getGameLinkSlice from "./slices/games/getGameListSlice";
import getLeaderboardSlice from "./slices/games/leaderboardSlice";
import getCasinoProfitLossBetsSlice from "./slices/bets/casinoBetsSlice";
import myCasinoBetsSlice from "./slices/bets/myBetsCasinoSlice";
import getBonusListSlice  from "./slices/profile/fetchBonusSlice";
import updateBonusSlice from "./slices/profile/updateBonusStatusSlice";
import deleteUserSlice from "./slices/profile/deleteUserSlice";
import depositListSlice from "./slices/payment/depositListSlice";
import depositSlice from "./slices/payment/depositSlice";
import withdrawSlice from "./slices/payment/withdrawSlice";
import withdrawListSlice from "./slices/payment/withdrawListSlice";

const appReducer = combineReducers({
  login: loginSlice,
  loginUsername:loginUsernameSlice,
  loginGoogle: loginGoogleSlice,
  config: configSlice,
  signup: signupSlice,
  verifyOtp: verifyOtpSlice,
  kycVerifyOtp: kycVerifyOtpSlice,
  resendOtp: resendOtpSlice,
  getProfile: getProfileSlice,
  getProfileKyc: getProfileKycSlice,
  editProfile: editProfileSlice,
  signout: signoutSlice,
  addKYC: addKYCSlice,
  resendOtpKYC: resendOtpKYCSlice,
  verifyOtpKYC: verifyOtpKYCSlice,
  updateProfile: updateProfileSlice,
  addBankDetail: addBankDetailSlice,
  getBankDetail: getBankDetailSlice,
  deleteBankDetail: deleteBankDetailSlice,
  location: locationReducer,
  getAllNotification: getAllNotificationSlice,
  markSeen: markSeenSlice,
  markSeenAll: markSeenAllSlice,
  getReferralEarning: getReferralEarningSlice,
  getDreamCasinoGames: getDreamCasinoGamesSlice,
  getCms: getCmsSlice,
  checkUser: checkUserSlice,
  getGameLink: getGameLinkSlice,
  getLeaderboard: getLeaderboardSlice,
  getCasinoProfitLossBets: getCasinoProfitLossBetsSlice,
  myCasinoBets: myCasinoBetsSlice,
  getBonusList: getBonusListSlice,
  updateBonus: updateBonusSlice,
  deleteUser: deleteUserSlice,
  device: deviceReducer,
  depositList: depositListSlice,
  deposit: depositSlice, 
  withdraw: withdrawSlice,
  withdrawList: withdrawListSlice
});
const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE") {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        serializableCheck: false,
        ignoredPaths: ["payload.headers"],
      },
    }),
});

export const persistor = persistStore(store);
